module.exports = __webpack_public_path__ + "img/itomanman_comic01.716febed.jpg";